<template>
    <div class="locations-module">
        <div class="map-content">
            <div class="map-sidebar">
                <div class="locations_wrapper">
                    <div :class="{'open': hasLocationInfoOpen}">
                        <div>
                            <div class="locations-header">
                                <h2>Find a Vicky Bakery</h2>
                                <div class="location_search_form">
                                    <div class="search_field">
                                        <input type="text" v-model="search" placeholder="Zip or City & State" />
                                        <i class="fal fa-search"></i>
                                    </div>
                                    <a @click="getUserLocation" title="Locate Me" target="" class="link-cta dark">
                                        <div class="wrap-link">
                                            <span class="link-text">Locate Me <i class="fal fa-location"></i></span>
                                        </div>
                                    </a>
                                </div>
                            </div>
                            <div class="overflow-list">
                                <div v-if="mappedLocations && mappedLocations.length" class="location-list">
                                    <div class="location-item" v-for="(location, index) in mappedLocations" @click="openLocationInfo(location)">
                                        <template>
                                            <div>
                                                <div class="name"><b>{{ location.title }}</b></div>
                                                <div class="address">{{ location.address && location.address.address }}</div>
                                                <div class="phone" v-if="location.phone_number && location.phone_number.url">
                                                    <a :href="location.phone_number.url">
                                                       {{location.phone_number.title}}
                                                    </a>
                                                </div>
                                                <div v-if="location.catering_menu">
                                                    <a :href="location.catering_menu" target="_blank">
                                                        <i class="fal fa-file-pdf"></i> Download Catering Menu
                                                    </a>
                                                </div>
                                                <div class="wrap-links">
                                                    <a v-if="location.pick_up && location.pick_up.url"
                                                       class="link-cta dark"
                                                       :href="location.pick_up.url"
                                                       target="_blank">
                                                        {{location.pick_up.title || 'Pick Up'}}
                                                    </a>
                                                    <a v-if="location.delivery && location.delivery.url"
                                                       class="link-cta dark"
                                                       :href="location.delivery.url"
                                                       target="_blank">
                                                        {{location.delivery.title || 'Delivery'}}
                                                    </a>
                                                </div>
                                            </div>
                                            <div class="location-cta">
                                                <i class="fas fa-heart" :class="{favorite: location.is_favorite}"></i>
                                                <i class="far fa-chevron-right"></i>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                                <div v-else="" class="no-data-found">
                                    <p>No locations found</p>
                                </div>
                            </div>
                        </div>
                        <div class="location-info">
                            <div class="row header-controls">
                                <i class="far fa-chevron-left" @click="closeLocationInfo"></i>
                            </div>
                            <location-details :location="selectedLocation"/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="map-wrapper">
                <div id="map"></div>
            </div>
        </div>
    </div>
</template>

<script>

    import _filter from 'lodash/filter';
    import _includes from 'lodash/includes';
    import LocationDetails from './LocationDetails';
    import {locationsApi} from "./includes/api";
    import zipcodes from 'zipcodes';
    import findNearestLocation from 'map-nearest-location';
    import _map from 'lodash/map'
    import _isEqual from 'lodash/isEqual'


    const {Map, Marker} = google.maps;

    export default {
        name: 'app',
        data() {
            return {
                search: '',
                mapCenter: {
                    lat: 25.7824141,
                    lng: -80.3678796
                },
                map: null,
                zoom: 8,
                selectedLocation: null,
                favLocation: null,
                hasLocationInfoOpen: false
            }
        },
        components: {LocationDetails},
        asyncComputed: {
            items() {
                return locationsApi.get('?per_page=100').then(res => res.data);
            },
        },
        computed: {
            locations() {
                let locations = [];

                const favLocationID = localStorage.getItem('vb_location_id');
                _.each(this.items, (location) => {
                    const {address} = location.acf;
                    const position = {
                        lat: +address.lat,
                        lng: +address.lng
                    };

                    let is_favorite = `${location.id}` === `${favLocationID}`;

                    let customLocation = {
                        id: location.id,
                        is_favorite,
                        title: location.title.rendered,
                        position,
                        ...location.acf
                    };

                    if (is_favorite) {
                        this.favLocation = customLocation;
                    }

                    locations.push(customLocation);
                    this.addLocationMarker(customLocation);
                });

                return locations;
            },
            mappedLocations() {
                let search = this.search.toLowerCase();

                const locations = _filter(this.locations, (location) => {
                    return _includes(location.title.toLowerCase(), search) || _includes(location.address.address, search);
                });

                if (locations.length) {
                    console.log('locations', locations);
                    return locations
                }

                const position = zipcodes.lookup(search);
                if (position !== undefined) {

                    const theLocation = {
                        lat: position.latitude,
                        lng: position.longitude
                    };

                    const latLngs = _map(this.locations, location => {
                        return {
                            lat: location.position.lat,
                            lng: location.position.lng
                        }
                    });

                    const res = findNearestLocation(theLocation, latLngs);

                    return _filter(this.locations, location => _isEqual(location.position, res.location))
                }

                return [];
            }
        },
        mounted() {
            let mapCenter = this.mapCenter;
            let zoom = 12;

            this.map = new Map(document.getElementById('map'), {
                zoom: zoom,
                center: mapCenter,
                streetViewControl: false,
                disableDefaultUI: true,
                zoomControl: true,
                zoomControlOptions: {
                    position: google.maps.ControlPosition.RIGHT_TOP
                },
            });

            let self = this;
            this.map.addListener('zoom', function() {
                self.zoom = this.map.getZoom();
            });

            // Custom Event that runs also on
            document.addEventListener("initUserLocation", function(event) {
                let {position} = event.detail;
                const {latitude, longitude} = position.coords;

                let centerMap = {
                    lat: latitude,
                    lng: longitude
                };

                if (self.favLocation) {
                    let {lat, lng} = self.favLocation.position;
                    centerMap = {lat, lng};
                }

                self.map.setCenter(centerMap);
                self.map.panTo(centerMap);

            });

        },
        methods: {
            getUserLocation() {
                window.getLocation();
            },
            getIcon(iconType) {
                if (iconType && iconType.selected) {
                    return this.getSelectedIcon();
                } else if (iconType && iconType.highlighted) {
                    return this.getHighlightedIcon();
                }
                return this.getDefaultIcon(iconType);
            },
            getDefaultIcon(isUserLocation = false) {
                const markerIconColor = isUserLocation ? '#00bddf' : '#D23730';
                const disabledMarkerIconColor = '#dadabb';
                return {
                    path: google.maps.SymbolPath.CIRCLE,
                    fillColor: markerIconColor,
                    fillOpacity: 1,
                    scale: 8,
                    strokeColor: '#ffffff',
                    strokeOpacity: 1,
                    strokeWeight: 1
                };
            },
            getLocationStatus(location) {
                // TODO timestamp based on current time
                return 'Open Closes 7PM';
            },
            getSelectedIcon() {
                return this.composeSVGIcon(selectedIcon);
            },
            composeSVGIcon(svgInfo) {
                const { imagesUrl } = this.props;
                return {
                    scaledSize: new window.google.maps.Size(svgInfo.width, svgInfo.height),
                    size: new window.google.maps.Size(svgInfo.width, svgInfo.height),
                    // let the icon be anchored to the map at the correct point in the image
                    anchor: new window.google.maps.Point(svgInfo.anchorX, svgInfo.anchorY),
                    // Join images root
                    url: `${imagesUrl}/${svgInfo.imagePath}`
                };
            },
            openLocationInfo(location) {
                this.selectedLocation = location;
                this.map.panTo(location.position);
                this.hasLocationInfoOpen = true;
            },
            closeLocationInfo() {
                this.hasLocationInfoOpen = false;
            },
            addLocationMarker(location) {

                const {position} = location;

                let markerOptions = {
                    map: this.map,
                    flat: true,
                    position: position,
                    icon: this.getDefaultIcon(),
                    optimized: false,
                    location: location,
                    zIndex: 1
                };

                let marker = new Marker(markerOptions);

                let self = this;
                marker.addListener('click', function() {
                    self.map.panTo(marker.getPosition());
                    self.openLocationInfo(marker.location);
                });
            },
            setFavoriteLocation(location) {
                localStorage.setItem('vb_location_id', location.id);
            }
        }
    }
</script>

<style lang="scss">

    .wrap-links {
        justify-content: flex-start;

        a {
            padding: 10px 30px;
        }
    }

    .locations-module {
        min-height: 100vh;
        padding-top: 72px;
    }

    #map {
        width: 100%;
        height: calc(100vh - 72px);
    }

    .map-content {
        display: flex;
        flex-direction: row;
        height: 100%;

        @media screen and (max-width: 960px) {
            flex-direction: column;
            height: 100%;
        }
    }

    .location_search_form {
        display: flex;
    }

    .locations_wrapper {
        overflow-x: hidden;
        width: 100%;

        > div {
            width: 200%;
            display: flex;
            transition: transform 0.5s ease-in-out 0s;
            transform: translateX(0);

            > div {
                width: 50%;
            }

            &.open {
                transform: translateX(-50%);
            }
        }
    }

    .location-list {
        width: 100%;
        /*height: 100%;*/
    }
    .no-data-found {
        border-top: 1px solid #DFDFDF;
        padding: 40px;
        width: 100%;
        text-align: center;

        p {
            font-size: 14px;
            font-weight: 600;
        }
    }
    .location-info {
        font-size: 13px;
        padding: 25px 0;
        width: 50%;

        .header-controls {
            i {
                cursor: pointer;
                width: 30px;
                height: 30px;
                display: flex;
                text-align: left;
                align-items: center;
            }
        }
        .row {
            padding: 0 40px;
        }

        h3, h4 {
            border-bottom: 1px solid #DFDFDF;
            padding: 0 40px 10px;
            font-size: 14px;
        }
    }

    .map-sidebar {
        width: 40vw;

        @media screen and (max-width: 960px){
            width: 100%;
        }
    }

    .map-wrapper {
        width: 60vw;
        height: 100%;

        @media screen and (max-width: 960px) {
            height: 100%;
            order: -1;
            width: 100%;

            #map {
                height: 350px;
            }
        }
    }

    .locations-header {
        padding: 50px 40px 30px;
        max-height: 220px;

        h2 {
            margin: 0;
            font-weight: normal;
            font-size: 60px;
        }

        .link-cta {
            display: inline-block;
            letter-spacing: 0;
            margin: 0;
        }

        @media screen and (min-width: 960px) and (max-width: 1200px){
            max-height: 263px;
        }

        @media screen and (max-width: 960px) {
            max-height: initial;
        }
    }

    .location_search_form {
        display: flex;
        lex-direction: row;
        justify-content: flex-end;
        align-items: flex-end;

        .search_field {
            margin-right: auto;
            width: 100%;
            max-width: calc(100% - 210px);
            position: relative;

            input {
                border: none;
                border-bottom: 1px solid currentColor;
                border-radius: 0;
                font-size: 12px;
                outline: none;
                padding: 0 10px;
                width: 100%;
            }

            i {
                color: #dfdfdf;
                position: absolute;
                right: 5px;
                font-size: 16px;
                bottom: 5px;
            }
        }

        .link-cta {
            min-width: 180px;
        }

        @media screen and (min-width: 960px) and (max-width: 1200px), (max-width: 560px) {
            flex-direction: column;
            justify-content: center;
            align-content: center;

            .search_field {
                max-width: 100%;
                margin-bottom: 20px;
            }
        }
    }

    .overflow-list {
        display: flex;
        height: calc(100vh - 292px);
        overflow: auto;

        @media screen and (min-width: 960px) and (max-width: 1200px) {
            height: calc(100vh - 335px);
        }
        @media screen and (max-width: 960px) {
            height: 100vh;
        }
    }

    .location-item {
        border-top: 1px solid #DFDFDF;
        cursor: pointer;
        display: flex;
        font-size: 14px;
        padding: 20px 40px;
        width: 100%;
        background-color: #fff;

        .location-cta {
            color: #DFDFDF;
            cursor: pointer;
            margin-left: auto;
            justify-content: center;
            align-items: center;
            display: flex;

            i {
                font-size: 16px;
                margin: 0 0 0 10px;
            }

            .favorite {
                color: #CE0E2D;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/App.vue